export default "__VITE_ASSET__NjOk$kBW__"